/* ZIZA: nieuwsbrief-forms posten naar join.zizaclub.com (Klaviyo lijst QT67m6)
   i.p.v. het Shopify customer-form. Verwijderen = deze file + de script-regel
   in layout/theme.liquid weghalen; het Shopify-form blijft dan als fallback werken. */
(function () {
  var script = document.currentScript;
  var successText = (script && script.dataset.success) || 'Thanks for subscribing';
  var errorText = (script && script.dataset.error) || 'Something went wrong. Please try again.';

  function showMessage(form, text, isError) {
    var existing = form.querySelector('.ziza-newsletter-message');
    if (existing) existing.remove();
    var el = document.createElement(isError ? 'small' : 'h3');
    el.className = 'ziza-newsletter-message newsletter-form__message form__message' +
      (isError ? '' : ' newsletter-form__message--success');
    el.textContent = text;
    if (isError) {
      var wrapper = form.querySelector('.newsletter-form__field-wrapper') || form;
      wrapper.appendChild(el);
    } else {
      var fields = form.querySelector('.newsletter-form__field-wrapper');
      if (fields) fields.style.display = 'none';
      form.appendChild(el);
      el.setAttribute('tabindex', '-1');
      el.focus();
    }
  }

  function bind(form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"], [name="commit"]');
      var email = input ? input.value.trim() : '';
      if (!email) return;
      if (button) button.disabled = true;
      fetch('https://join.zizaclub.com/subscribe', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email: email, source: 'Webshop signup box' })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('subscribe failed');
          showMessage(form, successText, false);
        })
        .catch(function () {
          showMessage(form, errorText, true);
          if (button) button.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('form.newsletter-form').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
